
import { Component, DoCheck, Inject, OnInit, NgZone, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import defaultLanguage from '../assets/i18n/es.json';
import enLanguage from '../assets/i18n/en.json';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { Keepalive } from '@ng-idle/keepalive';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { AuthService } from './services/auth.service';
import { StorageService } from './services/storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, DoCheck {

  window: any;
  options: Array<{ label: string }>;
  showIdle: boolean = false;
  idleState = 'Not started.';
  lastPing?: Date = null;

  constructor(private readonly translate: TranslateService,
    private readonly router: Router,
    @Inject(DOCUMENT) private readonly _document: any,
    private readonly zone: NgZone,
    private readonly idle: Idle,
    private readonly keepalive: Keepalive,
    private readonly authService: AuthService,
    private readonly storageService: StorageService,
    private readonly _elementRef: ElementRef
  ) {
    this.window = _document.defaultView;
    translate.addLangs(['es', 'en']);
    this.translate.setTranslation('es', defaultLanguage);
    this.translate.setTranslation('en', enLanguage);
    this.translate.setDefaultLang('en');
    this.options = new Array();
    this.options.push({ label: '/home/payment' });
    this.options.push({ label: 'e-tracking' });
    this.options.push({ label: 'claim' });
    this.options.push({ label: 'fetch-claim' });
    this.options.push({ label: '/home/ImpSupportMenu' });

    if (this.storageService.get("msal.idtoken")) {

      // sets an idle timeout of 1800 seconds = 30 minutes
      idle.setIdle(1800);
      // sets a timeout period of 900 seconds. after 60 seconds = 1 minute of inactivity, the user will be considered timed out.
      idle.setTimeout(60);
      // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
      idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      idle.onIdleEnd.subscribe(() => {
        this.idleState = 'No longer idle.'
        this.reset();
      });

      idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        this.showIdle = false;
        this.authService.logout();
      });

      idle.onIdleStart.subscribe(() => {
        this.idleState = 'You\'ve gone idle!'
        this.showIdle = true;
      });

      idle.onTimeoutWarning.subscribe((countdown) => {
        if (this.router.url.includes("prev-expo") || this.router.url.includes("prev-impo")) {
          let endSessionText = this.translate.instant('module.idle.endSession');
          let secondsText = this.translate.instant('module.idle.seconds');
          this.idleState = `¡${endSessionText} ${countdown} ${secondsText}!`;
        } else {
          this.reset();
        }
      });

      // sets the ping interval to 15 seconds
      this.keepalive.interval(15);

      this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

      this.reset();
    }

  }

  useLanguage(language: string) {
    this.translate.use(language);
  }

  ngOnInit() {
    this._elementRef.nativeElement.removeAttribute("ng-version");
  }

  ngDoCheck() {
    const currentUrl = this.router.url;
    if (!this.options.find(e => currentUrl.includes(e.label))) {
      this.unloadSurvey();
    }
  }

  unloadSurvey() {
    setTimeout(() => {
      if (typeof (this.window.QSI) !== undefined && typeof (this.window.QSI.API !== undefined))
        this.window.QSI.API.unload();
    }, 5000);
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.showIdle = false;
  }

}
